import { Field, FieldFooter } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import EquipmentCategoryForTypePicker from 'components/domain/equipment/EquipmentCategoriesForTypePicker/EquipmentCategoriesForTypePicker';
import { IEquipmentCategoryPickerProps } from '../EquipmentCategoryPicker/EquipmentCategoryPicker';

interface IEquipmentCategoryFormFieldProps extends Omit<IEquipmentCategoryPickerProps, 'value' | 'onSelect'> {
  className?: string | object;
  form: any;
  equipmentTypeId: string | null | undefined;
  name: string;
  onChange?: (value: string | null) => void;
  validations?: any;
}

function EquipmentCategoryFormField(props: IEquipmentCategoryFormFieldProps) {
  const { form, name, equipmentTypeId, validations, className, onChange, ...other } = props;

  const classes = classNames(
    {
      'equipment-category-picker-form-field': true,
    },
    className
  );

  function renderField({ ...fieldProps }) {
    function handleOnSelect(val: string | null) {
      fieldProps.handleChange(val, onChange);
    }

    return (
      <>
        <EquipmentCategoryForTypePicker
          error={fieldProps.hasError}
          value={form.state.data[name]}
          onSelect={handleOnSelect}
          equipmentTypeId={equipmentTypeId}
          {...other}
        />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  return <Field form={form} name={name} validations={validations} className={classes} render={renderField} />;
}

export default EquipmentCategoryFormField;
